var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCibTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 1.3645C19.9869 1.3645 1.34375 19.7936 1.34375 42.5364C1.34375 65.2792 19.9896 83.7083 43 83.7083C66.0104 83.7083 84.6562 65.2792 84.6562 42.5364C84.6562 19.7936 66.0104 1.3645 43 1.3645ZM63.4599 29.5712L56.6229 61.4143C56.1177 63.6722 54.7578 64.2193 52.8604 63.1568L42.4464 55.5706L37.4234 60.3518C36.8698 60.899 36.3995 61.3639 35.3245 61.3639L36.0636 50.8876L55.3625 33.6539C56.2037 32.9234 55.1771 32.509 54.0671 33.2395L30.2156 48.08L19.9359 44.9084C17.7026 44.2125 17.6515 42.7011 20.4062 41.6386L60.5682 26.3306C62.4333 25.6665 64.0619 26.7795 63.4572 29.5686L63.4599 29.5712Z",
    fill: "#191919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCibTelegram);
export default __webpack_public_path__ + "static/media/cib_telegram.7bed2a4912417e7b2b3ec718afd4d967.svg";
export { ForwardRef as ReactComponent };